import { FieldType } from '@wix/wix-data-schema-types'
import {
  GALLERY_ROLE,
  MEDIA_GALLERY_ROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
const {
  text,
  email,
  date,
  dateTime,
  number,
  url,
  stringArray,
  document,
  video,
  address,
  image,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Gallery',
  isConnectGfppEnabled: true,
  compactErrorPanel: false,
  supportsDefaultSelectedDataset: false,
  panel: {
    height: 525,
    title: 'Connect_Panel_Title_Gallery',
    helpId: 'bf7d9969-0ebd-4190-933f-507c03e9345c',
  },
  sections: [
    {
      role: GALLERY_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Gallery_Image_Sources_Label',
          prop: 'src',
          supportedFieldTypes: [image],
          defaultFieldType: image,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_Titles_Label',
          prop: 'title',
          supportedFieldTypes: [
            text,
            email,
            number,
            date,
            dateTime,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Gallery_Descriptions_Label',
          prop: 'description',
          supportedFieldTypes: [
            text,
            email,
            number,
            date,
            dateTime,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Gallery_Alt_Label',
          prop: 'alt',
          supportedFieldTypes: [
            text,
            email,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Gallery_Links_Label',
          prop: 'link',
          supportedFieldTypes: [document, url, image, video],
          defaultFieldType: url,
          supportPageLinks: true,
          supportsReferenceFields: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'gallery_live_preview_gfpp_desktop_main_action',
              label: 'Gallery_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
    },
    {
      role: MEDIA_GALLERY_ROLE,
      bindings: [],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'media_gallery_live_preview_gfpp_desktop_main_action',
              label: 'Media_Gallery_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
    },
  ],
})
